import { createApi } from '@reduxjs/toolkit/dist/query/react';
import B2ChatClient, { apiResource, b2chatBaseQuery } from '@src/client';

type LoginRequest = {
  username: string;
  password: string;
  rememberMe: boolean;
};

type LoginResponse = {
  authMethod?: 'otp_email' | 'totp';
  // These booleans are only present when true; absence means false.
  userHasTwoFactor?: boolean;
  twoFactorRequired?: boolean;
  needsTwoFaSetup?: boolean;
  enrollmentBlocking?: boolean;
};

const AuthApi = createApi({
  reducerPath: 'authApi',
  baseQuery: b2chatBaseQuery,
  endpoints: builder => ({
    login: builder.query<LoginResponse, LoginRequest>({
      query: data => {
        const formData = new FormData();
        formData.append('username', data.username);
        formData.append('password', data.password);
        formData.append('remember-me', String(data.rememberMe));

        return apiResource(B2ChatClient.resources.login.actions.userLogin, {
          data: formData,
        });
      },
      extraOptions: {
        maxRetries: 0,
      },
    }),
  }),
});

export default AuthApi;

export const { useLoginQuery, useLazyLoginQuery } = AuthApi;
